import { TFunction } from 'i18next';
import { IconActivity } from '@tabler/icons-react';
import { DateIndication } from '@/components/DateIndication';
import { UnderstandButton } from '@/components/Help/UnderstandButton';

interface KpiDashboardHeaderProps {
  t?: TFunction<undefined>;
  title: string | React.ReactNode;
  subtitle: string;
  updatedAt?: string;
}

export const KpiDashboardHeader = ({
  t,
  title,
  subtitle,
  updatedAt,
}: KpiDashboardHeaderProps) => (
  <header className="mb-6 border-b border-gray-DBDFE9 pb-4">
    <div className="flex flex-wrap items-center justify-between gap-4">
      <div className="flex items-center gap-3">
        <div
          className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl"
          style={{
            background:
              'linear-gradient(135deg, #5433FF, rgba(84, 51, 255, 0.4))',
          }}
        >
          <IconActivity className="h-5 w-5 text-white" stroke={2} />
        </div>
        <div>
          <h1 className="text-lg font-bold leading-tight text-black-071336">
            {title}
          </h1>
          <p className="text-xs text-gray-78829D">{subtitle}</p>
        </div>
        <UnderstandButton />
      </div>
      {updatedAt && <DateIndication t={t} date={updatedAt} />}
    </div>
  </header>
);
